import React from 'react'
import ICSButton from '../../../../components/ICS/Button/ICSButton'
import { downloadResultFile, getResultFile } from '../../../../redux/slices'
import { AppDispatch } from '../../../../services/lib'
import { useDispatch } from 'react-redux'
import { ResultFileDownloadResponse } from '../../../../types'
import { ResultFilesDataSourceItem } from '../ResultFilesModal/ResultFilesModal'

export const onDownloadClick = async (
  resultFileId: string,
  dispatch: AppDispatch,
  fileName: string
) => {
  const resultFileRes = await dispatch(
    getResultFile({
      resultFileId,
      query: {}
    })
  )

  if (resultFileRes.type.split('/').pop() === 'fulfilled') {
    await dispatch(
      downloadResultFile({
        data: (resultFileRes.payload as ResultFileDownloadResponse).file,
        fileName
      })
    )
  }
}

type RenderActionsProps = {
  row: ResultFilesDataSourceItem
}

const RenderActions: React.FC<RenderActionsProps> = ({ row }) => {
  const dispatch: AppDispatch = useDispatch()
  const validExtensions = ['dsr', 'mf4']
  const fileName = row.name
  const extension = fileName.split('.').pop()?.toLowerCase() || ''
  const hasDataspy = validExtensions.includes(extension)

  return (
    <div className="result-files-modal__actions">
      <ICSButton
        id={row.resultFileId}
        key={row.resultFileId}
        icon="download"
        type="default"
        stylingMode="contained"
        onClick={async () =>
          await onDownloadClick(row.resultFileId, dispatch, fileName)
        }
      />
      {hasDataspy && (
        <ICSButton
          id={`${row.resultFileId}-dataspy`}
          key={`${row.resultFileId}-dataspy`}
          icon="glyphicons glyphicons-stats"
          type="default"
          stylingMode="contained"
          onClick={() => window.open(row.dataSpy, '_blank')}
        />
      )}
    </div>
  )
}

export default RenderActions
